import { NgModule } from '@angular/core';
// PrimeNg
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ToolbarModule } from 'primeng/toolbar';
import { MegaMenuModule } from 'primeng/megamenu';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { TabViewModule } from 'primeng/tabview';
import { SplitterModule } from 'primeng/splitter';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ListboxModule } from 'primeng/listbox';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { InputNumberModule } from 'primeng/inputnumber';
import { BadgeModule } from 'primeng/badge';
import { FocusTrapModule } from 'primeng/focustrap';
import { CarouselModule } from 'primeng/carousel';

@NgModule({
  exports: [
    CarouselModule,
    ButtonModule,
    CardModule,
    FieldsetModule,
    DividerModule,
    AccordionModule,
    MenubarModule,
    InputTextModule,
    CheckboxModule,
    ToolbarModule,
    MegaMenuModule,
    ToastModule,
    DialogModule,
    SelectButtonModule,
    CalendarModule,
    AutoCompleteModule,
    PaginatorModule,
    TableModule,
    ProgressBarModule,
    DropdownModule,
    MultiSelectModule,
    ConfirmDialogModule,
    SkeletonModule,
    TabViewModule,
    SplitterModule,
    ConfirmPopupModule,
    TooltipModule,
    MessageModule,
    OverlayPanelModule,
    ListboxModule,
    BlockUIModule,
    PanelModule,
    InputNumberModule,
    BadgeModule,
    FocusTrapModule
  ]
})
export class PrimeNgModule {}
